import { Action } from '@ngrx/store';

export enum ClearStateActionTypes {
  LOGOUT = '[App] logout'
}

export class Logout implements Action {
  readonly type = ClearStateActionTypes.LOGOUT;
}

export type ClearStateActions = Logout;
